// extracted by extract-css-chunks-webpack-plugin
module.exports = {"qrCode":"qrCode-eTNXqj_Q","closeBtn":"closeBtn-1kZxXozC"};